import KebabDiningIcon from '@mui/icons-material/KebabDining';
import RamenDiningIcon from '@mui/icons-material/RamenDining';
import DinnerDiningIcon from '@mui/icons-material/DinnerDining';
import BreakfastDiningIcon from '@mui/icons-material/BreakfastDining';
import LunchDiningIcon from '@mui/icons-material/LunchDining';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CircleIcon from '@mui/icons-material/Circle';
import GrassIcon from '@mui/icons-material/Grass';
import EggIcon from '@mui/icons-material/Egg';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CameraIcon from '@mui/icons-material/Camera';
import HomeIcon from '@mui/icons-material/Home';

const getMenuIcon = (slug: string) => {
  switch(slug) {
    case "home":
      return <HomeIcon sx={{color: "white"}} />;
    case "gallery":
      return <CameraIcon sx={{color: "white"}} />;
    case "apps":
      return <KebabDiningIcon sx={{color: "white"}} />;
    case "soups":
      return <RamenDiningIcon sx={{color: "white"}} />;
    case "entrees":
      return <DinnerDiningIcon sx={{color: "white"}} />;
    case "sandwiches":
      return <LunchDiningIcon sx={{color: "white"}} />;
    case "breakfast":
      return <EggIcon sx={{color: "white"}} />;
    case "sides":
      return <BreakfastDiningIcon sx={{color: "white"}} />;
    case "salads":
      return <GrassIcon sx={{color: "white"}} />;
    case "specials":
      return <AttachMoneyIcon sx={{color: "white"}} />;
    case "chefspecials":
      return <FavoriteIcon sx={{color: "white"}} />;
    default:
      return <CircleIcon sx={{color: "white"}} />;
  }

};
export { getMenuIcon };
